import axios, { AxiosError, AxiosResponse } from 'axios';
import { IResponseDataRefresh, IDeliveryInformation } from './types';
import { IPdpResponseData } from './pdpTypes';
export class Fetch {
    private apiLink: string;

    private detailComponentEndpoint = 'productdetailspage/componentsdata';
    private dataRefreshEndpoint = 'flexiblesetpage/componentsdatarefresh';
    
    constructor(apiLink) {
        this.apiLink = apiLink;
        this.handleError.bind(this);
    }

    public dataRefresh(fsCode: string, masterArticleNo: number,
        salesArticleVariantKey: string, brickNo: number, brickItemNo: number,
        otherSelected:
            {
                masterArticleNo: number;
                salesArticleVariantKey: string;
                brickItemNo: number;
                brickNo: number;
                deliveryInformation: IDeliveryInformation;
                availabilityState: number
            }[]
    ): Promise<IResponseDataRefresh> {
        const urlToHost = this.apiLink;
        const apiUrl = urlToHost + this.dataRefreshEndpoint;

        const requestUrl = new URL(apiUrl);

        const dataRefreshPayload = {
            'fsCode': fsCode,
            'changed': {
                'masterArticleNo': masterArticleNo,
                'salesArticleVariantKey': salesArticleVariantKey,
                'brickNo': brickNo,
                'brickItemNo': brickItemNo
            },
            'otherSelected': otherSelected
        };

        return axios
            .post(requestUrl.toString(), dataRefreshPayload, { timeout: 3500 })
            .then((response: AxiosResponse) => (response.status === 200 ? response.data : undefined))
            .catch(error => this.handleError(error));
    }

    // obsolete will be removed later:
    public fetch(
        salesArticleNo: string,
        colorCode: string,
        masterArticleNo: number,
        sizeCode: string,
        navigationKey?: string,
        wwsStatus?: string
    ): Promise<IPdpResponseData> {
        const urlToHost = this.apiLink;
        const apiUrl = urlToHost + this.detailComponentEndpoint;

        const requestUrl = new URL(apiUrl);
        requestUrl.searchParams.set('salesArticleNo', salesArticleNo);
        requestUrl.searchParams.set('colorCode', colorCode);
        requestUrl.searchParams.set('masterArticleNo', masterArticleNo.toString());

        if (navigationKey) requestUrl.searchParams.set('navigationKey', navigationKey);
        if (sizeCode) requestUrl.searchParams.set('sizeCode', sizeCode);
        if (wwsStatus) requestUrl.searchParams.set('availabilityStatus', wwsStatus);

        return axios
            .get(requestUrl.toString(), { timeout: 3500 })
            .then((response: AxiosResponse) => (response.status === 200 ? response.data : undefined))
            .catch(error => this.handleError(error));
    }

    public getBasketItemCount(apiUrl: string, savKey: string): Promise<number> {
        const requestUrl = new URL(apiUrl);
        requestUrl.searchParams.set('savKeyList', savKey);

        return axios
            .get(requestUrl.toString())
            .then((response: AxiosResponse) => {
                if (response.status !== 200 || !response.data) return 1;
                //service can handle multiple but we only care about one
                const savKeyToCount: { [savKey: string]: number } = response.data;
                if (!(savKey in savKeyToCount)) return 1;
                return savKeyToCount[savKey];
            })
            .catch(error => this.handleError(error));
    }
    
    public getPriceListForSizes(apiLink: string, savKeys: string[]):
        Promise<object> {
        const apiUrl = apiLink + 'flexiblesetpage/sizesprice';
        const requestUrl = new URL(apiUrl);
        savKeys.forEach(savKey => {
            requestUrl.searchParams.append('sizeSavKeys', savKey);
        });

        return axios
            .get(requestUrl.toString())
            .then((response: AxiosResponse) => {
                if (response.status !== 200 || !response.data) return 1;
                return response.data;
            })
            .catch(error => this.handleError(error));
    }

    public getBasketFlexibleSetAmount(apiUrl: string, basketItemId: string): Promise<number> {
        const requestUrl = new URL(this.apiLink + apiUrl + basketItemId);

        return axios
            .get(requestUrl.toString())
            .then((response: AxiosResponse) => {
                if (response.status !== 200 || !response.data) return 1;
                return response.data?.amount;
            })
            .catch(error => this.handleError(error));
    }

    private handleError(error: Error | AxiosError) {
        const errorMsg = this.isAxiosError(error) ? error.message : `${error.name}: ${error.message}`;
        const errorStack = this.isAxiosError(error) ? JSON.stringify(error.toJSON()) : error.stack;
        // eslint-disable-next-line no-console
        console.warn(`ajax fetch failed with "${errorMsg}". Full error:\n${errorStack}`);
        return 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private isAxiosError(error: any): error is AxiosError {
        return typeof error.toJSON !== 'undefined';
    }
}
